module.exports = "<nv-react-component component=\"CollectionRoutes\"></nv-react-component>";